// Mapes routes to action types.
import { redirect } from 'redux-first-router';

import * as types from './actions/actionTypes';
import {
    loadPatternFromRoute,
    loadSewpatFromRoute,
    patternsByCategory,
    patternsFromDesigner,
    siteSearch,
} from './actions/navigation';
import {
    fetchPatterns,
    loadFavoritesPatterns,
    loadSubCategories,
    loadTopCategories,
} from './actions/patterndesignActions';
import { setActiveSewpat } from './actions/sewpats';
import { getCurrentPageNumber } from './reducers/page';
import { getActiveSewpatId } from './reducers/sewpats';
import { getPatternPerPage } from './reducers/ui.patterngallery';

const routesMap = {

    [types.NAVIGATED_TO_HOME]: '/:language(de|en|fr)?',
    NOT_FOUND: {
        path: '/:language(de|en|fr)?/not-found',
        thunk: (dispatch, getState) => {
            const action = redirect({ type: types.NAVIGATED_TO_HOME });
            dispatch(action);
        },
    },

    [types.NAVIGATED_TO_CHECKOUT_COMPLETED]: {
        path: '/:language(de|en|fr)?/shop/checkout/completed',
        thunk: (dispatch, getState) => {
            const action = redirect({ type: types.NAVIGATED_TO_HOME });
            dispatch(action);
        },
    },

    [types.NAVIGATED_TO_ABOUT]: '/:language(de|en|fr)?/about',
    [types.NAVIGATED_TO_TOS]: '/:language(de|en|fr)?/legal/tos',
    [types.NAVIGATED_TO_IMPRINT]: '/:language(de|en|fr)?/legal/imprint',
    [types.NAVIGATED_TO_PRIVACY]: '/:language(de|en|fr)?/legal/privacy',
    [types.NAVIGATED_TO_CONTACT]: '/:language(de|en|fr)?/contact',
    [types.NAVIGATED_TO_HASHTAG]: '/:language(de|en|fr)?/hashtag',

    [types.NAVIGATED_TO_NEWSLETTER_FORM]: '/:language(de|en|fr)?/newsletter/subscribe',
    [types.NAVIGATED_TO_NEWSLETTER_SUBSCRIBED]: {
        path: '/:language(de|en|fr)?/newsletter/subscribed',
        thunk: (dispatch, getState) => {
            const action = redirect(
                { type: types.NAVIGATED_TO_NEWEST_PATTERNGALLERY });
            dispatch(action);
        },
    },

    [types.NAVIGATED_TO_FAQ_RECOLORING]: '/:language(de|en|fr)?/faq/umfaerben',
    [types.NAVIGATED_TO_FAQ_FABRICS]: '/:language(de|en|fr)?/faq/stoffe',
    [types.NAVIGATED_TO_FAQ_SEWPATS]: '/:language(de|en|fr)?/faq/schnittmuster',
    [types.NAVIGATED_TO_FAQ_SHIPPING]: '/:language(de|en|fr)?/faq/shipping',

    [types.NAVIGATED_TO_TOPCATEGORIES]: {
        path: '/:language(de|en|fr)?/categories',
        thunk: loadTopCategories(),
    },

    [types.NAVIGATED_TO_SUBCATEGORIES]: {
        path: '/:language(de|en|fr)?/categories/:categoryid',
        thunk: loadSubCategories(),
    },

    [types.NAVIGATED_TO_CATEGORIE_PATTERNS_GALLERY]: {
        path: '/:language(de|en|fr)?/schnittmuster/:sewpatId/categories/:categoryid/patterns',
        thunk: patternsByCategory(),
    },

    [types.NAVIGATED_TO_SEWPAT_PATTERN_GALLERY]: {
        path: '/:language(de|en|fr)?/schnittmuster/:sewpatId/pattern/:categoryid?',
        thunk: loadSewpatFromRoute(),
    },

    [types.NAVIGATED_TO_SINGLE_PATTERN_VIEW]: {
        path: '/:language(de|en|fr)?/schnoff/:sewpatId/:patternid',
        thunk: loadPatternFromRoute(),
    },

    [types.NAVIGATED_TO_SEWPAT_VIEW]: {
        path: '/:language(de|en|fr)?/schnittmuster/:sewpatId',
        thunk: loadSewpatFromRoute(),
    },

    [types.NAVIGATED_TO_SEWPAT_GALLERY]: '/:language(de|en|fr)?/schnittmuster',

    [types.NAVIGATED_TO_SEARCHGALLERY]: {
        path: '/:language(de|en|fr)?/search',
        thunk: siteSearch(),
    },

    [types.NAVIGATED_TO_DEFAULT_NEWEST_PATTERNGALLERY]: {
        path: '/:language(de|en|fr)?/neueste-muster',
        thunk: async (dispatch, getState) => {
            const sewpatId = getActiveSewpatId(getState());
            const action = redirect({
                type: types.NAVIGATED_TO_NEWEST_PATTERNGALLERY,
                payload: { sewpatId },
            });
            dispatch(action);
        },
    },

    [types.NAVIGATED_TO_NEWEST_PATTERNGALLERY]: {
        path: '/:language(de|en|fr)?/schnittmuster/:sewpatId/neueste-muster',
        thunk: async (dispatch, getState) => {
            const state = getState();
            const page = getCurrentPageNumber(state);
            const count = getPatternPerPage(state);
            const sewpatId = (
                state.location.payload || {}
            ).sewpatId || 'pony';
            const query = {
                sort: 'newestFirst',
                limit: count,
                offset: page ? (
                    page - 1
                ) * count : 0,
            };
            await Promise.all([
                dispatch(setActiveSewpat(sewpatId)),
                dispatch(fetchPatterns(query))]);
        },
    },

    [types.NAVIGATED_TO_PATTERNS_FROM_DESIGNER]: {
        path: '/:language(de|en|fr)?/designerinnen/:designerid/:sewpatId/patterns',
        thunk: patternsFromDesigner(),
    },

    [types.NAVIGATED_TO_COLOR_SEARCHGALLERY]: '/:language(de|en|fr)?/search/color/:color',
    [types.NAVIGATED_TO_SIMILIAR_PATTERNS_VIEW]: '/:language(de|en|fr)?/search/similiar/:patternid',

    [types.NAVIGATED_TO_LOVED_PATTERNS]: {
        path: '/:language(de|en|fr)?/schnoffe-merkliste',
        thunk: loadFavoritesPatterns(),
    },

    [types.NAVIGATED_TO_SETTINGS]: '/:language(de|en|fr)?/settings',

    [types.NAVIGATED_TO_COLORSWATCHES_CART_FORM]: '/:language(de|en|fr)?/shop/colorswatches',
};

export default routesMap;



// WEBPACK FOOTER //
// ./src/routesMap.js